import { render, staticRenderFns } from "@/components/Layout/Menu/Administracion/Administracion_camiones/Administracion_camiones.html?vue&type=template&id=50239e10&scoped=true&"
import script from "@/components/Layout/Menu/Administracion/Administracion_camiones/Administracion_camiones.js?vue&type=script&lang=js&"
export * from "@/components/Layout/Menu/Administracion/Administracion_camiones/Administracion_camiones.js?vue&type=script&lang=js&"
import style0 from "@/components/Layout/Menu/Administracion/Administracion_camiones/Administracion_camiones.css?vue&type=style&index=0&id=50239e10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50239e10",
  null
  
)

export default component.exports